import { Mui } from "@osu/react-ui";
import useAutoCompleteReviewers from "./hooks/useAutoCompleteReviewers";

const AutoComplete = (props = {}) => {
  const { id, reviewer, setReviewer, type } = props;
  const { options } = useAutoCompleteReviewers({type: type})
  return (
    <Mui.Autocomplete
      id={id}
      options={options}
      getOptionLabel={(option) => option.label || ""}
      getOptionSelected={(option, value) => option.emplid === value.emplid}
      value={reviewer}
      onChange={(e, value) => setReviewer(value || "")}
      style={{ minWidth: 300}}
      slotProps={{ endAdornment: { sx: { top: 'calc(50% - 20px)' } } }}
      renderInput={(params) => (
        <Mui.TextField {...params} label={"Choose Reviewer"} variant="outlined" />
      )}
    />
  );
}

export default AutoComplete;
